export default "__VITE_ASSET__919b3584__"